export enum MarketingDevicePlatform {
	IOS = 'ios',
	ANDROID = 'android',
}

export interface MarketingDevice {
	id: string;
	platform: MarketingDevicePlatform;
}
